import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Segment, Image } from 'semantic-ui-react';
import i18next from 'i18next';

import { encryptStringData, decryptStringData } from '../../helpers/encryption';
import { login } from '../../actions';
import logoIcon from '../../assets/images/logo.png';

import './Login.scss';

class Login extends Component {
    state = { identity: '', password: '' };

    handleSubmit = (event) => {
        const { identity, password } = this.state;
        if (identity && password) {
            this.props.login({ identity, password });
        }
        event.preventDefault();
    }

    render() {
        const { token } = this.props;

        if (token) {
            return <Redirect to={{ pathname: '/' }} />;
        }

        return (
            <Grid
                textAlign='center'
                verticalAlign='middle'
                className='pi-login'
            >
                <Grid.Column className='pi-login-main-column'>
                    <Image src={logoIcon} size="tiny" centered className='pi-paidit-logo' />
                    <Header as='h2' textAlign='center' className='pi-login-header'>
                        {i18next.t('login.title')}
                    </Header>
                    <Form size='large' onSubmit={this.handleSubmit}>
                        <Segment stacked>
                            <Form.Input
                                fluid
                                icon='user'
                                iconPosition='left'
                                placeholder={i18next.t('login.usernameOrEmail')}
                                value={this.state.identity}
                                onChange={({ target }) => this.setState({ identity: target.value })}
                                required
                            />
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder={i18next.t('password')}
                                type='password'
                                value={this.state.password ? decryptStringData(this.state.password) : this.state.password}
                                onChange={({ target }) => this.setState({ password: encryptStringData(target.value) })}
                                required
                            />

                            <Button color='blue' fluid size='large' className='pi-login-button'>
                                {i18next.t('login.self')}
                            </Button>
                        </Segment>
                        <a href='/password/recovery' className='pi-login-password-recovery'>{i18next.t('passwordRecovery.forgot')}</a>
                    </Form>
                </Grid.Column>
            </Grid >
        );
    }
}

Login.propTypes = {
    token: PropTypes.string,
    login: PropTypes.func,
    
};

const mapStateToProps = (state) => {
    const { token } = state.auth;

    return { token };
};

export default connect(mapStateToProps, { login })(Login);
